import "core-js/modules/es.array.push.js";
import api from "@/api";
import { ElMessage } from "element-plus";
import constants from "@/utils/constants";
import NoteDataChart from "@/components/chart/NoteDataChart.vue";
export default {
  name: "MaterialDetailView",
  components: {
    NoteDataChart
  },
  data() {
    return {
      tagColors: ['#FF0000', '#FFA500', '#FFD700', '#008000', '#00BFFF', '#4169E1', '#800080', '#FF69B4', '#00FF00', '#30D5C8'],
      materialId: this.$route.params.materialId,
      material: {},
      sourceFile: [],
      downloadSourceFile: false
    };
  },
  methods: {
    toEdit() {
      this.$router.push('/editor/' + this.material.id);
    },
    convertTextToHTML(text) {
      if (!text) {
        return '';
      }
      // 将换行符转换为 <br/>
      let formattedText = text.replace(/\n/g, '<br/>');

      // 正则表达式用于匹配 URL，直到遇到空白、标点或特殊字符为止
      // 排除的字符包括：空格（\s），逗号（, 和 ，），句号（. 和 。），问号（? 和 ？），感叹号（! 和 ！），分号（;）
      formattedText = formattedText.replace(/(http[s]?:\/\/[^\s,!?;，。？！;]+)/g, '<a href="$1" target="_blank">$1</a>');
      return formattedText;
    },
    getFileIcon(url) {
      return constants.getFileIcon(url);
    },
    copyTitle() {
      try {
        navigator.clipboard.writeText(this.material.title);
        ElMessage.success('复制成功');
      } catch (err) {
        ElMessage.error('复制失败');
      }
    },
    copyContent() {
      try {
        navigator.clipboard.writeText(this.extractPlainText(this.material.content));
        ElMessage.success('复制成功');
      } catch (err) {
        ElMessage.error('复制失败');
      }
    },
    extractPlainText(html) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || "";
    },
    download() {
      api.downloadAsZipFile(this.materialId, this.downloadSourceFile).then(ret => {
        window.open(ret + "?downloadSourceFile=" + this.downloadSourceFile);
      });
    },
    init() {
      api.getMaterial(this.materialId).then(result => {
        this.material = {
          ...result,
          tags: [...result.tags, result.bizName, result.platformName]
        };
      });
    }
  },
  mounted() {
    this.init();
  }
};